<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template v-if="user" #button-content>
      <div class="d-sm-flex d-none user-nav">
        <p class="user-name font-weight-bolder mb-0">
          {{ user.fullName || user.userName }}
        </p>
        <span class="user-status">{{ user.role }}</span>
      </div>
      <b-avatar
        size="40"
        :src="profileImage"
        variant="light-primary"
        class="badge-minimal"
        badge
        :badge-variant="userOnlineStatus === 'online' ? 'success' : 'secondary'"
      >
        <feather-icon
          v-if="!user.profile.image"
          icon="UserIcon"
          size="22"
        />
      </b-avatar>
    </template>

<!--    <b-dropdown-item-->
<!--      :to="{ name: 'pages-profile'}"-->
<!--      link-class="d-flex align-items-center"-->
<!--    >-->
<!--      <feather-icon-->
<!--        size="16"-->
<!--        icon="UserIcon"-->
<!--        class="mr-50"-->
<!--      />-->
<!--      <span>Profile</span>-->
<!--    </b-dropdown-item>-->
<!--    <b-dropdown-item-->
<!--      :to="{ name: 'apps-email' }"-->
<!--      link-class="d-flex align-items-center"-->
<!--    >-->
<!--      <feather-icon-->
<!--        size="16"-->
<!--        icon="MailIcon"-->
<!--        class="mr-50"-->
<!--      />-->
<!--      <span>Inbox</span>-->
<!--    </b-dropdown-item>-->
<!--    <b-dropdown-item-->
<!--      :to="{ name: 'apps-todo' }"-->
<!--      link-class="d-flex align-items-center"-->
<!--    >-->
<!--      <feather-icon-->
<!--        size="16"-->
<!--        icon="CheckSquareIcon"-->
<!--        class="mr-50"-->
<!--      />-->
<!--      <span>Task</span>-->
<!--    </b-dropdown-item>-->
    <b-dropdown-item
      :to="{ name: 'profile.index' }"
      link-class="d-flex align-items-center"
      :link-class="currentRouteName === 'profile.index' ? 'active' : ''"
    >
      <feather-icon
        size="16"
        icon="UserIcon"
        class="mr-50"
      />
      <span>{{ $t('Profile') }}</span>
    </b-dropdown-item>
    <b-dropdown-item
      :to="{ name: 'gifts' }"
      link-class="d-flex align-items-center"
      :link-class="currentRouteName === 'gifts' ? 'active' : ''"
    >
      <feather-icon
        size="16"
        icon="GiftIcon"
        class="mr-50"
      />
      <span>{{ $t('My Gifts') }}</span>
    </b-dropdown-item>
    <b-dropdown-item
      :to="{ name: 'buying-contents' }"
      link-class="d-flex align-items-center"
      :link-class="currentRouteName === 'buying-contents' ? 'active' : ''"
    >
      <feather-icon
        size="16"
        icon="ImageIcon"
        class="mr-50"
      />
      <span>{{ $t('Purchased') }}</span>
    </b-dropdown-item>

    <b-dropdown-divider />

<!--    <b-dropdown-item-->
<!--      :to="{ name: 'pages-account-setting' }"-->
<!--      link-class="d-flex align-items-center"-->
<!--    >-->
<!--      <feather-icon-->
<!--        size="16"-->
<!--        icon="SettingsIcon"-->
<!--        class="mr-50"-->
<!--      />-->
<!--      <span>Settings</span>-->
<!--    </b-dropdown-item>-->
<!--    <b-dropdown-item-->
<!--      :to="{ name: 'pages-pricing' }"-->
<!--      link-class="d-flex align-items-center"-->
<!--    >-->
<!--      <feather-icon-->
<!--        size="16"-->
<!--        icon="CreditCardIcon"-->
<!--        class="mr-50"-->
<!--      />-->
<!--      <span>Pricing</span>-->
<!--    </b-dropdown-item>-->
<!--    <b-dropdown-item-->
<!--      :to="{ name: 'pages-faq' }"-->
<!--      link-class="d-flex align-items-center"-->
<!--    >-->
<!--      <feather-icon-->
<!--        size="16"-->
<!--        icon="HelpCircleIcon"-->
<!--        class="mr-50"-->
<!--      />-->
<!--      <span>FAQ</span>-->
<!--    </b-dropdown-item>-->

    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="logout"
    >
      <feather-icon
        size="16"
        icon="LogOutIcon"
        class="mr-50"
      />
      <span>{{ $t('Logout') }}</span>
    </b-dropdown-item></b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar,
} from 'bootstrap-vue'
import { initialAbility } from '@/libs/acl/config'
import useJwt from '@/auth/jwt/useJwt'
import { avatarText } from '@core/utils/filter'
import { logout } from '@/helpers/helpers'

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
  },
  data() {
    return {
      user: JSON.parse(localStorage.getItem('user')),
      avatarText,
    }
  },
  computed: {
    currentRouteName() {
      return this.$route.name
    },
    profileImage() {
      return this.$store.getters['auth/profileImage']
    },
    userOnlineStatus() {
      return this.$store.getters['auth/userOnlineStatus']
    },
  },
  methods: {
    logout() {
      logout(this.$ability, this.$router, this.$store)
    },
  },
}
</script>
